import {
  API,
  Request
} from '@/lib/index.js'

export default {
  namespaced: true,
  state: {
    ruleId: '',
    ancestors: [],
    htmlMainBody: '',
    operationTimestamp: null,
    title: '',
    hasPermission: true,
    page: 'Detail',
    pdfUrl: ''
  },
  mutations: {
    updatePage (state, page = 'Detail') {
      state.page = page
    },
    updateRuleId (state, ruleId) {
      state.ruleId = ruleId
    },
    updateDetail (state, payload) {
      const {
        ancestors,
        htmlMainBody,
        operationTimestamp,
        title,
        hasPermission,
        pdfUrl
      } = payload
      state.ancestors = ancestors || []
      state.htmlMainBody = htmlMainBody || ''
      state.operationTimestamp = operationTimestamp
      state.title = title
      state.hasPermission = hasPermission
      state.pdfUrl = pdfUrl
    }
  },
  getters: {

  },
  actions: {
    getRuleDetail ({state, commit}) {
      return new Promise((resolve, reject) => {
        Request(API.getRuleDetail, {
          ruleId: state.ruleId
        }).then((resp) => {
          let result = resp || {}
          let detail = result.detail || {}
          let permission = result.permission || {}
          result = Object.assign({}, detail, permission)
          resolve(result)
          commit('updateDetail', result)
        }).catch((resp) => {
          console.log('getRuleDetail error', resp)
          reject({})
        })
      })
    }
  }
}
